import React, { lazy } from "react";
import { Button } from "react-bootstrap";
import CatalogContext from "../../../../../contexts/CatalogContext";
import Catalog from "../../../../../models/Catalog";

const ItemInquiryDialog = lazy(() => import("./ItemInquiryDialog"));
import("./ItemInquiryButton.scss");



export default function ItemInquiryButton({ item, form }) {
	const [modalIsOpen, setModalIsOpen] = React.useState(false);

	const showModal = () => setModalIsOpen(true);
	const closeModal = () => setModalIsOpen(false);

	const [ catalog ] = React.useContext(CatalogContext);

	const isLivePlus = React.useMemo(() => Catalog.Is_Live_Plus(catalog), [catalog]);
	const contactLabel = isLivePlus ? "Product Inquiry" : "Contact Us";

	return (
		<>
			{ !isLivePlus && (
				<Button
					className="item-inquiry-button"
					variant="secondary"
					onClick={showModal}
				>
					{ contactLabel }
				</Button>
			)}
			{ modalIsOpen && (
				<React.Suspense fallback={<></>}>
					<ItemInquiryDialog
						item={item}
						form={form}
						open={modalIsOpen}
						onClose={closeModal}
					/>
				</React.Suspense>
			)}
		</>
	);
}